// extracted by mini-css-extract-plugin
export default {"ActionMenu_Overlay":"sort-by-menu-module__ActionMenu_Overlay__isuhtPR","Box":"sort-by-menu-module__Box__NU3gq0M","Box_1":"sort-by-menu-module__Box_1__YrtrK12"};